import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bulma/css/bulma.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents)

Vue.config.productionTip = false

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner, faEnvelope, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faSpinner)
library.add(faEnvelope)
library.add(faUser)
Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  created () {
    AOS.init({offset: 200, duration: 800, easing: 'ease-in-sine', delay: 50})
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
